import { render, staticRenderFns } from "./micro.vue?vue&type=template&id=1ca5b2b7&scoped=true&"
import script from "./micro.vue?vue&type=script&lang=js&"
export * from "./micro.vue?vue&type=script&lang=js&"
import style0 from "./micro.vue?vue&type=style&index=0&id=1ca5b2b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5b2b7",
  null
  
)

export default component.exports